import api from '@http/api';
import { FormatDate } from '@src/utils/formats';

export interface IGetAllIntencoesTable {
  //modelo: ISolicitacaoResultTable[];
  id: number;
  descricao: string;
  dataCadastro: string;
  statusAtivo: number;
}


export interface IRequestIntencao {
  descricao: string;
}

export interface IDesativarIntencao{
  id: number;
}

class Services {
  public async CreateIntencao(data: IRequestIntencao) {
    return await api
      .post('/api/TipoIntencaoMissa/CreateTipoIntencaoMissa', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }


  public async DesativarIntencao({ id }: IDesativarIntencao) {
      return await api
        .patch(`/api/TipoIntencaoMissa/UpdateStatus?id=${id}`)
        .then(() => {
          return {
            error: false,
          };
        })
        .catch(() => {
          return {
            error: true,
          };
        });
    }


}

export default Services;
